export default __webpack_public_path__ + "static/media/Teacher3.5032be4d.jpg";